import randomFilename from './randomFilename';

const renameFile = fileName => {
  if (fileName === 'image.png') return randomFilename('IMG');

  return fileName.toString().replaceAll('_', ' ');
};

export default renameFile;
